/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: ryanxu ryanxu@chaocanshu.ai
 * @LastEditTime: 2026-03-25 19:11:05
 * @FilePath: /knit-web/src/locale/zh-CN/common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  common: {
    login: '登录',
    submit: '提交',
    reject: '拒绝',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    ok: '确定',
    reset: '重置',
    publish: '发布',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    copySuccess: '复制成功',
    copyFailed: '复制失败，您的浏览器可能不支持或已禁止该操作',
    getFailed: '获取数据失败',
    time: {
      justNow: '刚刚',
      yearsAgo: '{count}年前',
      monthsAgo: '{count}个月前',
      daysAgo: '{count}天前',
      hoursAgo: '{count}小时前',
      minutesAgo: '{count}分钟前',
      secondsAgo: '{count}秒前',
    },
    credits: '积分',
    overview: '概览',
    search: '搜索',
    pleaseInput: '请输入 {name}',
    pleaseSelect: '请选择 {name}',
    goToExternalConfiguration: '前往外部配置',
    required: '{name} 是必填项',
    unknownError: '未知错误',
    userDisabled: {
      title: '账号已被禁用',
      content: '您的账号已被禁用，请联系管理员',
    },
    documentation: '文档',
    contactUs: '联系我们',
    logOut: '退出登录',
    debugSettings: '调试设置',
    deleteConfirmTitle: '删除确认',
    workspaceLimitExceeded: '最多可创建 {max} 个工作空间',
  },
  exception: {
    result: {
      403: {
        description: '您的账号已被禁用',
        detail:
          '经过对您近期活动的自动审查，您的账号已被禁用。请查看我们的服务条款和使用政策以获取更多信息。如果您希望对封禁提出申诉，请联系管理员。',
        back: '返回登录',
      },
    },
  },
  workspaceLimitExceeded: '最多可创建 {max} 个工作空间',
  columnsShowSelector: {
    title: '列管理',
    columnName: '名称',
  },
};
